var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 3.106c3.256 2.278 5.47 4.56 6.76 6.08.544.64.816.961.897 1.534.021.15.021.41 0 .56-.081.573-.353.894-.897 1.535-1.29 1.52-3.504 3.8-6.76 6.08-.91.636-1.365.954-1.822.963a1.565 1.565 0 0 1-1.273-.663c-.255-.38-.255-.97-.255-2.152 0-.512 0-.769-.089-.965a.995.995 0 0 0-.492-.496c-.195-.09-.451-.093-.962-.097-2.806-.023-5.22.158-7.296 3.566a.92.92 0 0 1-.78.449.86.86 0 0 1-.865-.884c.316-8.844 5.383-11.453 8.948-11.997.586-.09.88-.134 1.047-.233a.907.907 0 0 0 .416-.484c.073-.18.073-.436.073-.945 0-1.182 0-1.773.255-2.152.271-.403.787-.672 1.273-.663.457.009.912.327 1.822.964Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare24);
export default __webpack_public_path__ + "static/media/share_24.ba384a6c.svg";
export { ForwardRef as ReactComponent };